
<template>
	<div id="map" style="width: 100%; height: 180px; background: #eee;z-index: 1;top:0;right:0"></div>
    <!-- <div id="marker"></div> -->
    <div id="centerLocation" class="d-none"></div>
</template>
<script setup>
import { onMounted,defineProps} from "vue";
let props = defineProps(["location"]);
onMounted(() => {
	// مختصات میدان مرکزی
	var lat = props.location.lat
	var lang = props.location.lng
	const myMap = new nmp_mapboxgl.Map({
        mapType: 'neshanRaster',
        container: "map",
        zoom: 15,
        pitch: 0,
        center: [lang, lat],
        trackResize: true,
        interactive: false,
        mapKey: "web.0f8e46e0aba84f5fbdcf09ae6b11532d",
        poi: true,
        traffic: false,
        mapTypeControllerStatus: {
            show: false,
            position: 'top-left'
        }
    })

    const el = document.createElement('div');
    el.className = 'marker';

    new nmp_mapboxgl.Marker(el)
        .setLngLat([lang,lat])
        .addTo(myMap);
})

</script>
<style>
.marker{
	background: url("https://safir.radap.ir/static/img/myLocation.png");
    background-size: cover;
    width: 32px;
    height: 40px;
    top: -20px;
    cursor: pointer;
}
.leaflet-bar a, .leaflet-bar a:hover {
    width: 30px;
    height: 30px;
}
.active{
    color: #F00 !important
}
.map-input-group {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;
}
.map-input-group-text {
    display: flex;
    align-items: center;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: center;
    white-space: nowrap;
    background-color: #e9ecef;
    border: 1px solid #ced4da;
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
}
.map-input-group>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
    margin-left: -1px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.map-input-group>.map-form-control, .map-input-group>.map-form-select {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
}
.map-form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 0.25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
#myLocationBTN{
    width: 32px;
    height: 32px;
    position: absolute;
    z-index: 999;
    top: 80px;
    left: 10px;
}
#myLocationBTN svg{
    vertical-align:middle;
}
#marker{
	background: url("https://safir.radap.ir/static/img/myLocation.png");
	background-size: cover;
	width: 46px;
	height: 60px;
	z-index: 999;
	position: absolute;
	left: calc(50% - 25px);
	top: calc(50% - 60px);
}
#map {
	height: 100%;
	width: 100%;
}
#centerLocation{
    background-color: white;
    border: solid 1px #AAAAAA;
    padding: 4px;
    border-radius: 50px;
    width: 320px;
    height: 30px;
    z-index: 998;
    position: absolute;
    left: calc(50% - 160px);
    text-align: center;
    top: 78%;
}
.mapboxgl-ctrl-bottom-right{
	display: none;
}
.wm-container{
    display: none !important;
}
.control{
    display: none !important;
}
</style>

